import { render, staticRenderFns } from "./ModalFooterButton.vue?vue&type=template&id=bc148e66&"
import script from "./ModalFooterButton.vue?vue&type=script&lang=js&"
export * from "./ModalFooterButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports